<template>
  <history-stack
    :default-view-component="() => import('./GeotagCard.vue')"
    v-bind="$attrs"
    @stack:close="handleClose"
  />
</template>

<script>
export default {
  name: 'GeotagHistoryStack',
  setup(props, { root }) {
    const handleClose = () => {
      root.$router.push({
        name: 'geotags'
      });
    };
    return {
      handleClose
    };
  }
};
</script>
